import objectAssignDeep from "deps/object-assign-deep";

// util for updating state object
export const update = (state, newData) => objectAssignDeep({}, state, newData);

// creates a slicer for a given exclude array (key names)
export const slicer = (exclude) => {
  return (state) => {
    if (!state) return state;
    const newState = {};
    for(let key in state) {
      if (!state.hasOwnProperty(key)) continue;
      if (exclude.indexOf(key) >= 0) continue;
      newState[key] = state[key];
    }
    return newState;
  }
};




// WEBPACK FOOTER //
// ./src/state/util.js